import { render, staticRenderFns } from "./SpeakerTag.vue?vue&type=template&id=a0f27094&lang=pug&"
import script from "./SpeakerTag.vue?vue&type=script&lang=js&"
export * from "./SpeakerTag.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports